import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deactivateOverlay } from "../../../state/activedFlows/actions";
import {
  handleAddCustomNote,
  handleUpdateCustomNoteLocation,
} from "../../../state/activedFlows/actions";
import { v4 as uuid } from "uuid";

const Overlay = ({ reactFlowInstance, reactFlowWrapper }) => {
  const overlayState = useSelector((state) => state.activedFlows.overlay);
  const dispatch = useDispatch();

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const [transform, setTransfrom] = useState(1);

  useEffect(() => {
    if (reactFlowInstance) {
      setTransfrom(reactFlowInstance.toObject().zoom);
    }
  }, [overlayState.isActive]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePosition({
        x: event.clientX,
        y: event.clientY,
      });
    };

    if (overlayState.isActive && reactFlowWrapper.current) {
      reactFlowWrapper.current.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      if (reactFlowWrapper.current) {
        reactFlowWrapper.current.removeEventListener(
          "mousemove",
          handleMouseMove
        );
      }
    };
  }, [overlayState.isActive]);

  if (!overlayState.isActive || !reactFlowInstance || !reactFlowWrapper.current)
    return null;

  const renderShadowNote = () => {
    let style = {};

    switch (overlayState.operation) {
      case "add":
        if (transform) {
          style = {
            width: 200 * transform + "px",
            height: 50 * transform + "px",
            backgroundColor: "rgba(255, 207, 153, 1.0)",
            borderRadius: "5px",
          };
        }
        break;

      case "move":
        if (transform && overlayState.noteStyle) {
          const { width, height, backgroundColor } = overlayState.noteStyle;
          style = {
            width: width * transform + "px",
            height: height * transform + "px",
            backgroundColor: backgroundColor,
            borderRadius: "5px",
          };
        }
        break;

      default:
        return null;
    }

    return (
      <div
        style={{
          position: "absolute",
          left: mousePosition.x,
          top: mousePosition.y,
          opacity: 0.5,
          ...style,
        }}
      />
    );
  };

  const onOverlayClick = (event) => {
    const rect = reactFlowWrapper.current.getBoundingClientRect();
    const position = reactFlowInstance.project({
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    });

    if (overlayState.operation === "add") {
      const id = uuid();

      dispatch(
        handleAddCustomNote({
          flowId: overlayState.flowId,
          id,
          position,
        })
      );
    } else if (overlayState.operation === "move" && overlayState.noteId) {
      const noteId = overlayState.noteId;
      const newPosition = position;
      dispatch(
        handleUpdateCustomNoteLocation({
          noteId,
          newPosition,
        })
      );
    }

    dispatch(deactivateOverlay());
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.1)",
        zIndex: 1000,
        cursor: "crosshair",
      }}
      onClick={onOverlayClick}
    >
      {renderShadowNote()}
    </div>
  );
};

export default Overlay;
